gsap.registerPlugin(ScrollTrigger);

window.addEventListener('load', function () {
  const lenis = window.lenis = new Lenis({
    duration: 1.2,
    easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
    smoothWheel: true,
    touchMultiplier: 2,
    prevent: function (node) {
      return !!node.closest('#arcana-portal');
    },
  });

  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
  gsap.ticker.lagSmoothing(0);

  initMobileMenu();
});

function initMobileMenu() {
  const menuButton = document.querySelector('.header__menu-button');
  const closeButton = document.querySelector('.ps-mobile-menu__close');
  const mobileMenu = document.querySelector('.ps-mobile-menu');
  const mobileLinks = document.querySelectorAll('.ps-mobile-menu__link');

  if (!menuButton || !mobileMenu) return;

  menuButton.addEventListener('click', function () {
    mobileMenu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (closeButton) closeButton.addEventListener('click', closeMenu);

  mobileLinks.forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });
}
